var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AwesomeCrud',_vm._g(_vm._b({attrs:{"apiTimeout":120000,"savePaginationState":false}},'AwesomeCrud',_vm.modelComputed,false),_vm.events))
}
var staticRenderFns = []

export { render, staticRenderFns }